import { useState } from "react";
import { motion } from "framer-motion";
import harmeet from "../Images/harmeet.jpeg";
import G from "../Images/G.png";
import LN from "../Images/Linkedin.png";
import bhumi from "../Images/bhumi.jpeg";
import Priyank from "../Images/Priyank.png";

const ProfileCard = ({
  name,
  title,
  image,
  bg,
  description,
  linked,
  industry,
  yearsDM,
}) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="relative w-80 h-96 cursor-pointer [perspective:1000px]"
      onClick={() => setFlipped(!flipped)}
    >
      <motion.div
        className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d]"
        animate={{ rotateY: flipped ? 180 : 0 }}
      >
        {/* Front Side */}
        <div
          className="absolute w-full h-full bg-gray-600 rounded-2xl flex flex-col justify-end border border-white"
          style={{ backfaceVisibility: "hidden" }}
        >
          {bg && (
            <img
              src={bg}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover rounded-2xl opacity-20"
            />
          )}
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
            {image && (
              <img
                src={image}
                alt={name}
                className="w-full h-full object-cover rounded-2xl"
              />
            )}
          </div>
          <div className="relative bg-white w-[90%] mx-auto mb-5 p-4 rounded-xl z-10">
            <h3 className="text-lg font-semibold">{name}</h3>
            <p className="text-gray-400">{title}</p>
            <div className="absolute bottom-4 right-4">
              <a href={linked} target="_blank" rel="noreferrer">
                <img src={LN} alt="LinkedIn" className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        {/* Back Side */}
        <div
          className="absolute w-full h-full bg-[#FFFFFF33] rounded-2xl border border-white text-white flex flex-col justify-between p-4"
          style={{
            transform: "rotateY(180deg)",
            backfaceVisibility: "hidden",
          }}
        >
          <div className="flex flex-col bg-[#0F172B] rounded-md items-center">
            <img
              src={image}
              alt={name}
              className="w-24 h-24 object-cover rounded-full border-2 font-[Nunito] border-white mt-4"
            />
            <h3 className="text-lg font-semibold mt-2 font-[Nunito]">{name}</h3>
            <p className="text-sm text-gray-300 font-[Nunito]">{title}</p>
          </div>

          <div className="flex justify-around mt-4">
            <div className="flex flex-col items-center bg-gray-600 px-3 py-2 rounded-lg border border-white">
              <p className="text-[14px] text-white text-center">
                Years in Industry
              </p>
              <p className="text-lg font-bold font-[Nunito]">{industry}+</p>
            </div>
            <div className="flex flex-col items-center bg-gray-600 px-3 py-2 rounded-lg border border-white">
              <p className="text-[14px] font-[Nunito] text-white text-center">
                Years at DM
              </p>
              <p className="text-lg font-bold">{yearsDM}+</p>
            </div>
          </div>

          <p className="text-sm text-gray-300 mt-2 text-justify">
            {description}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

const ProfileGrid = () => {
  const profiles = [
    {
      name: "Harmeet Godhani",
      title: "CEO & Founder",
      image: harmeet,
      bg: G,
      description:
        "Harmeet Godhani is the visionary CEO & Founder of the company, driving innovation and strategic growth. With a passion for technology and leadership, he has laid the foundation for a future-focused organization.",
      linked: "https://www.linkedin.com/in/harmeet-godhani-78a129245/",
      industry: "5",
      yearsDM: "3",
    },
    {
      name: "Priyank Godhani",
      title: "Co-Founder & CTO",
      image: Priyank,
      bg: G,
      description:
        "Priyank Godhani is the Co-Founder & CTO, architecting the company’s cutting-edge tech solutions. He transforms innovative ideas into powerful digital experiences with a future-ready mindset.",
      linked: "https://www.linkedin.com/in/priyank-godhani/",
      industry: "5",
      yearsDM: "2",
    },
    {
      name: "Bhumi Godhani",
      title: "CMO",
      image: bhumi,
      bg: G,
      description:
        "Bhumi Godhani is the CMO, streamlining operations with precision and purpose. He ensures seamless execution across teams, turning vision into scalable success.",
      linked:
        "https://www.linkedin.com/in/bhumi-godhani-662135328?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      industry: "4",
      yearsDM: "3",
    },
  ];

  return (
    <section className="bg-[#0F172A] py-10 px-4 md:px-6">
      <motion.div
        className="w-full max-w-2xl mx-auto text-center"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <motion.div
          className="inline-block bg-[#432DD7] font-[Nunito] text-white px-10 py-4 rounded-full text-[16px] font-semibold mb-3"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          Our Team
        </motion.div>

        <p
          className="text-white text-[20px] md:text-[40px] mt-2"
          style={{ fontFamily: "PT Sans" }}
        >
          Success is driven by our team’s
        </p>

        <p
          className="text-white text-[20px] md:text-[40px] leading-relaxed"
          style={{ fontFamily: "Allison, sans-serif" }}
        >
          commitment to continuous improvement and learning
        </p>
      </motion.div>

      <div className="max-w-[70rem] mx-auto">
        <div className="p-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-20 justify-items-center">
          {profiles.map((profile, index) => (
            <ProfileCard key={index} {...profile} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProfileGrid;
